const config = {
  baseUrl:
    process.env.NODE_ENV === "development"
      ? "http://localhost:8000"
      : "https://api.getyourfakeid.com",
};

export default config;
